import {request} from "@@/plugin-request/request";
import type {DoubleCallParams} from './data'

export async function DoubleCallPhone (params: DoubleCallParams) {
  return request('/core/call/addRecord', {
    params,
  })
};

/**
 *获取双呼权限
 */
export async function getFocusMetrics() {
  return request('/core/call/isCallEnable')
}
